import React, { useEffect, useRef, useState } from 'react';
import Button from '../../components/Button/Button';
import { Link, useNavigate } from 'react-router-dom';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { DateRange } from 'react-date-range';
import { format } from 'date-fns';
import { bankInfo, currency, invoiceItem } from '../../utils/constant';
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';
import useFormValidation from '../../hooks/useFormValidation';
import { accomodationFormValidationSchema, validate } from '../../utils/formValidation';
import { convertToSubcurrency, normalizeDate } from '../../utils/utility';
import { getPassportById } from '../../services/studentApi';
import { errorToast } from '../../utils/errorHandling';
import { AiOutlineLoading } from 'react-icons/ai';
import { toast } from 'react-toastify';
import { Elements } from "@stripe/react-stripe-js";
import { postAccomodationById } from '../../services/accomodationApi';
import { loadStripe } from '@stripe/stripe-js';
import Checkout from '../../components/Checkout';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
const base_url = process.env.REACT_APP_BASE_URL;

const CreateAccomodation = () => {
    const { t } = useTranslation();
    const currencyCopy = currency(t);
    const bankInfoCopy = bankInfo(t);
    const invoiceItemCopy = invoiceItem(t)
    const [formSection, setFormSection] = useState(1);
    const [formData, setFormData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [passportRegion, setPassportRegion] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { errors, validateField, validateAllFields } = useFormValidation(accomodationFormValidationSchema(t));
    const navigate = useNavigate();
    const [extendStayDay, setExtendStayDay] = useState(0);
    const [earlyStayDay, setEarlyStayDay] = useState(0);
    const [formPercentage, setFormPercentage] = useState("33%");
    const [selectedRoom, setSelectedRoom] = useState('');
    const [paymentMethod, setPaymentMethod] = useState('');
    const [currencySelected, setCurrencySelected] = useState({
        key: "",
        currency: "",
        rate: 1,
    });
    const [checkoutItem, setCheckoutItem] = useState({
        selectedRoomAmount: 0,
        earlyStayAmount: 0,
        extendStayAmount: 0,
        tourismTax: 0,
    });
    const [transactionFee, setTransactionFee] = useState(0);
    const [totalAmount, setTotalAmount] = useState({ totalAmount: 0, totalAmountInCurrencySelected: 0 });
    const [netTotalAmount, setNetTotalAmount] = useState(0);
    // const [selectionRange, setSelectionRange] = useState({
    //     startDate: new Date('2025-03-25'),
    //     endDate: new Date('2025-04-02'),
    //     key: 'selection',
    // });
    // const [openDatePicker, setOpenDatePicker] = useState(false);
    // const calendarRef = useRef(null);
    // const buttonRef = useRef(null);

    useEffect(() => {
        setFormData({
            is_compliance_health_measure: "",
            room_type: "",
            check_in_date: "",
            is_early_check_in: "",
            check_out_date: "",
            is_extend_stay: "",
            is_addon_bed: "",
            is_roommate: "",
            roommate_id: "",
            roommate_name: "",
            roommate_relationship: "",
            payment_mode: "",
            offline_payment_currency: "",
            offline_payment_prove: "",
        })
        const fetchPassport = async () => {
            try {
                const data = await getPassportById();
                if (data) {
                    setPassportRegion(data.passport_region);
                    setIsLoading(false);
                }
            } catch (error) {
                errorToast(error, t("Passport.warning"), t);
                setIsLoading(false);
            }
        };
        fetchPassport();
    }, [])

    useEffect(() => {
        setCheckoutItem((prevState) => ({
            ...prevState,
            earlyStayAmount: earlyStayDay * invoiceItemCopy.filter((item) => item.key === "earlyStay").map((item) => item.amount)[0],
            extendStayAmount: extendStayDay * invoiceItemCopy.filter((item) => item.key === "extendStay").map((item) => item.amount)[0],
        }));
        if (passportRegion !== "Malaysia" && passportRegion !== "") {
            setCheckoutItem((prevState) => ({
                ...prevState,
                tourismTax: (extendStayDay + earlyStayDay + 7) * invoiceItemCopy.filter((item) => item.key === "tourismTax").map((item) => item.amount)[0],
            }));
        }
        setFormData((prevState) => ({
            ...prevState,
            is_early_check_in: earlyStayDay !== 0 ? 1 : 0,
            is_extend_stay: extendStayDay !== 0 ? 1 : 0,
        }))
    }, [earlyStayDay, extendStayDay]);

    useEffect(() => {
        let totalNet = (Number(checkoutItem.earlyStayAmount) +
            Number(checkoutItem.extendStayAmount) +
            Number(checkoutItem.selectedRoomAmount)
        ).toFixed(2);
        let totalSum = (Number(totalNet) + Number(checkoutItem.tourismTax) + Number(transactionFee)).toFixed(2);
        let totalInCurrencySelected = (Number(totalSum) * Number(currencySelected.rate)).toFixed(2);
        setNetTotalAmount(totalNet);
        setTotalAmount({
            totalAmount: totalSum,
            totalAmountInCurrencySelected: totalInCurrencySelected
        });

    }, [checkoutItem, transactionFee, currencySelected]);

    useEffect(() => {
        setTransactionFee(paymentMethod === "creditcard" ? ((0.04 * (Number(netTotalAmount) + Number(checkoutItem.tourismTax)) + 1) / 0.96).toFixed(2) : 0);
    }, [totalAmount, paymentMethod])

    // useEffect(() => {
    //     const handleClickOutside = (event) => {
    //         if (calendarRef.current && !calendarRef.current.contains(event.target) &&
    //             buttonRef.current && !buttonRef.current.contains(event.target)) {
    //             setOpenDatePicker(false);
    //         }
    //     };

    //     if (openDatePicker) {
    //         document.addEventListener("mousedown", handleClickOutside);
    //     } else {
    //         document.removeEventListener("mousedown", handleClickOutside);
    //     }

    //     return () => {
    //         document.removeEventListener("mousedown", handleClickOutside);
    //     };
    // }, [openDatePicker]);

    const navigateFormSection = (forward) => {
        let validationFields = [];
        if (forward) {
            switch (formSection) {
                case 2:
                    validationFields = ["is_compliance_health_measure"]
                    break;
                case 3:
                    validationFields = ["room_type", "is_roommate", "check_in_date", "check_out_date", "payment_mode", "is_addon_bed"]
                    formData.is_roommate === "1" && validationFields.push("roommate_id", "roommate_name", "roommate_relationship")
                    formData.payment_mode === "offline" && validationFields.push("offline_payment_currency", "offline_payment_prove")
                    break;
            }
        };
        if (validateAllFields(formData, validationFields)) {
            const section = forward ? formSection + 1 : formSection - 1;
            setFormSection(section);
            const percentage = (section / 3) * 100;
            const percentageString = percentage + "%";
            setFormPercentage(percentageString);
        } else {
            toast.error(t("general.ValidateFailed"));
        }
    }

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [formSection])

    const handleCurrencyChange = (e) => {
        const { id, value } = e.target;
        const currencyInfo = currencyCopy.filter((item) => item.key === value);
        setCurrencySelected({
            key: currencyInfo.length >= 1 ? currencyInfo[0].key : "",
            currency: currencyInfo.length >= 1 ? currencyInfo[0].currency : "",
            rate: currencyInfo.length >= 1 ? currencyInfo[0].rate : 1
        });
        setFormData((prevState) => ({
            ...prevState,
            [id]: value,
        }));
        validateField(id, value)
    }

    const handleInputChange = (e) => {
        const { id, value, name } = e.target;

        if (name === "is_addon_bed" || name === "payment_mode") {
            setFormData((prevState) => ({
                ...prevState,
                [name]: id,
            }));
            if (name === "payment_mode") {
                setPaymentMethod(id);
                setCurrencySelected({
                    key: "",
                    currency: "",
                    rate: 1
                });
            }
            validateField(name, id);

        } else if (id === "is_compliance_health_measure") {
            let checkBoxValue = e.target.checked === true ? "1" : "";
            setFormData((prevState) => ({
                ...prevState,
                [id]: checkBoxValue
            }));
            validateField(id, checkBoxValue);
        } else if (name === "is_roommate") {
            if (id === "1") {
                setFormData((prevState) => ({
                    ...prevState,
                    [name]: id,
                }));
            } else {
                setFormData((prevState) => ({
                    ...prevState,
                    [name]: id,
                    roommate_id: "",
                    roommate_name: "",
                    roommate_relationship: ""
                }));
            }
            validateField(name, id);
        } else if (id === "check_in_date" || id === "check_out_date") {
            setFormData((prevState) => ({
                ...prevState,
                [id]: value,
            }));
            validateField(id, value);
            if (id === "check_in_date") {
                const desiredStartDate = normalizeDate(value);
                const startDate = normalizeDate('2025-03-26');
                setEarlyStayDay(
                    (startDate - desiredStartDate) / (1000 * 60 * 60 * 24) // Convert milliseconds to days
                );
            } else {
                const desiredEndDate = normalizeDate(value);
                const endDate = normalizeDate('2025-04-01');
                setExtendStayDay(
                    (desiredEndDate - endDate) / (1000 * 60 * 60 * 24) // Convert milliseconds to days
                );
            }

        } else {
            setFormData((prevState) => ({
                ...prevState,
                [id]: value,
            }));
            validateField(id, value);
        }
    };

    const handleCancel = () => {
        navigate(`${base_url}/view-accommodation`);
    };

    const [fileError, setFileError] = useState("");
    const maxSize = 2 * 1024 * 1024; // 2MB in bytes
    const handleFileChange = (event) => {
        const { id } = event.target;
        const selectedFile = event.target.files[0];
        const allowedTypes = [
            "image/jpeg",
            "image/png",
            "application/pdf",
            "image/jpg",
            "image/heic"
        ];
        if (selectedFile && !allowedTypes.includes(selectedFile.type)) {
            setFileError(t("FormValid.FileExtensionAllow"));
            event.target.value = ""; // Clear the file input
            return;
        } else if (selectedFile && selectedFile.size > maxSize) {
            setFileError(t("FormValid.smallerFile"));
            event.target.value = ""; // Clear the file input
            return;
        } else {
            setFileError("");
            setFormData((prevState) => ({
                ...prevState,
                [id]: selectedFile,
            }));
            validateField(id, selectedFile);
        }
    };

    const handleRoomSelection = (roomId) => {
        setSelectedRoom(roomId);
        setFormData((prevState) => ({
            ...prevState,
            "room_type": roomId,
        }));
        validateField("room_type", "roomId");

        setCheckoutItem((prevState) => ({
            ...prevState,
            selectedRoomAmount: invoiceItemCopy.filter((item) => item.key === roomId).map((item) => item.amount)[0],
        }));
    };
    const setNullFormToEmpty = (nullFormData) => {
        for (const [key, value] of Object.entries(nullFormData)) {
            if (value === null || value === undefined) {
                nullFormData[key] = ''; // Replace with an empty string
            }
        }
        return nullFormData;
    }
    const generateValidationFields = () => {
        let validationFields = ["is_compliance_health_measure", "is_addon_bed", "room_type", "is_roommate", "check_in_date", "check_out_date", "payment_mode"];
        formData.is_roommate === "1" && validationFields.push("roommate_id", "roommate_name", "roommate_relationship");
        formData.payment_mode === "offline" && validationFields.push("offline_payment_currency", "offline_payment_prove");
        return validationFields;
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {
            let transformedFormData = setNullFormToEmpty(formData);
            let validationFields = generateValidationFields();

            if (validateAllFields(transformedFormData, validationFields) && fileError === "") {
                // Step 4: Submit form data
                const combinedFormData = {
                    ...formData,
                    ...checkoutItem,
                    ...totalAmount,
                    transactionFee: transactionFee,
                    netTotalAmount: netTotalAmount,
                    payment_type: "Payment"
                };
                const response = await postAccomodationById(combinedFormData);
                if (response) {
                    toast.success(t("accomodation.SubmitSuccess"));
                    navigate(`${base_url}/view-accommodation`);
                }
            } else {
                toast.error(t("general.ValidationFail"));
                setIsSubmitting(false); // Re-enable the button
                return;
            }

        } catch (error) {
            // General error handling
            errorToast(error, t("general.Error"), t);
        } finally {
            // Ensure the button is re-enabled regardless of outcome
            setIsSubmitting(false);
        }
    };

    return (
        <>
            {passportRegion === "" ?
                <div className='info-container'>
                    <h3>{t("accomodation.title")}</h3>
                    <p>{t("accomodation.title2")}</p>
                    {isLoading ?
                        <>
                            <AiOutlineLoading className='spin' />
                            <p>{t("accomodation.Loading1")}</p>
                        </>
                        :
                        <>
                            <p style={{ "color": "#ff0000" }}><Trans key="accommodation" html="br:<br/>">
                                <br />{t("accomodation.Ppfirst")}
                            </Trans></p>
                            <div className='action-buttons'>
                                <Link to={`${base_url}/submit-passport`}>
                                    <Button
                                        buttonStyle='btn--primary'
                                        buttonSize='btn--small'
                                    >{t("general.SubmitInfo")}</Button>
                                </Link>

                            </div>
                        </>
                    }
                </div>
                :
                <>
                    <div className='info-container'>
                        <h3>{t("accomodation.title")}</h3>
                        <p>{t("accomodation.title2")}</p>
                        <div className='action-buttons'>
                            <Button buttonStyle='btn--primary' buttonSize='btn--small' onClick={handleCancel} type="button">{t("general.BTNcancel")}</Button>
                        </div>
                    </div>
                    <div className='form-wrapper'>
                        <h4 className='d-flex mt-3 justify-content-left'>{t("general.Page")} {formSection} {t("general.OF3")}</h4>
                        <div className="progress mb-5">
                            <div className="progress-bar bg-success" role="progressbar" style={{ "width": formPercentage }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                        <form>
                            <div className='form-section-1' hidden={formSection !== 1}>
                                <p>

                                    ☘️
                                    <strong> {t("accomodation.title3")}</strong>
                                    {t("accomodation.title3_1")}
                                    <Trans key="accomodation" html="br/:<br />">
                                        <br />{t("accomodation.title3Time")}
                                    </Trans>

                                </p>
                                <br />
                                <p>
                                    ☘️
                                    <strong> {t("accomodation.TitleFee")}</strong>
                                </p>
                                <p>
                                    <strong>{t("accomodation.TitleRoom")}</strong>
                                    <br />
                                    <Trans key="accommodation" html="br:<br/>">
                                        {t("accomodation.RoomOP")}
                                    </Trans>

                                </p>
                                <p>
                                    <strong>{t("accomodation.roomTypeTitle")}</strong>
                                    <br />
                                    <Trans key="accommodation" html="br:<br/>">
                                        {t("accomodation.roomTypeDescription")}
                                    </Trans>
                                </p>
                                <p><br /><strong>{t("accomodation.includeFeesTitle")}</strong>
                                    <Trans key="accommodation" html="br:<br/>">
                                        <br />{t("accomodation.roomFees")}
                                    </Trans>
                                </p>
                                <p>
                                    <br />
                                    <strong>{t("accomodation.Sentence1")}</strong>
                                    <span style={{ "color": "#ff0000" }}>
                                        <strong> {t("accomodation.Sentence2")}</strong>
                                    </span>
                                    :<br />{t("accomodation.feeContent1")}
                                </p>
                                <p>&nbsp;</p>
                                <p>
                                    ☘️<strong> {t("accomodation.BefnAft")}</strong>
                                </p>
                                <p>
                                    <strong>{t("accomodation.roomOP2")}</strong>
                                    <br /><Trans key="accomodation" html="br:<br/>">
                                        {t("accomodation.roomFee2")}
                                    </Trans>

                                </p>
                                <p><br />
                                    <strong>{t("accomodation.reservationSuggestion")}</strong>
                                    <br />
                                    <Trans key="accomodation" html="br:<br/> ">
                                        {t("accomodation.OP2content")}
                                    </Trans>
                                </p>
                                <p>{t("accomodation.OP2content1")}&nbsp;
                                    <strong>
                                        {t("accomodation.OP2content2")}&nbsp;
                                        <span style={{ "color": "#ff0000" }}>
                                            {t("accomodation.OP2content3")}
                                        </span>
                                    </strong>
                                </p>
                                <p>&nbsp;</p>
                                <p><strong>{t("accomodation.reminder")}</strong>
                                    <br />📌 {t("accomodation.policy")}
                                    <span style={{ "color": "#ff0000" }}><strong> {t("accomodation.norefund")}</strong></span>{t("accomodation.thank")}</p>
                                <p>&nbsp;</p>
                            </div>
                            <div className='form-section-2' hidden={formSection !== 2}>
                                <p>
                                    {t("accomodation.Warn")}
                                </p>
                                {<p>
                                    {t("accomodation.Warn1")}
                                    <strong> {t("accomodation.Warn1_2")}</strong>
                                </p>}
                                <p>
                                    {t("accomodation.Warn2")}
                                    <strong> {t("accomodation.Warn2_1")} </strong>
                                    {t("accomodation.Warn2_2")}
                                </p>
                                <Trans key="accomodation" html="br:<br/>">
                                    {t("accomodation.Warn3")}
                                </Trans>
                                <div className="form-item mt-5">
                                    <label>{t("accomodation.Pledge")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                    <div className="d-flex gap-2">
                                        <input type="checkbox" className="form-check-input" id="is_compliance_health_measure" onChange={handleInputChange} required />
                                        <p className='m-0'>{t("accomodation.Pledge2")}</p>
                                    </div>
                                </div>
                                {errors.is_compliance_health_measure && <span className="error">{errors.is_compliance_health_measure}</span>}
                            </div>
                            <div className='form-section-3' hidden={formSection !== 3}>
                                <div>
                                    <p><strong>{t("accomodation.reminder")}</strong>
                                        <br />📌 {t("accomodation.policy")}
                                        <span style={{ "color": "#ff0000" }}><strong> {t("accomodation.norefund")}</strong></span>{t("accomodation.thank")}</p>
                                    <h4 className='mt-5'>{t("accomodation.StayOP")}</h4>
                                    <table className="table table-info table-striped">
                                        <thead>
                                            <tr>
                                                <th scope="col"></th>
                                                <th scope="col">{t("Constant.TwinRoom")}<br />{t("Constant.twinBedSize")}</th>
                                                <th scope="col">{t("Constant.KingRoom")}<br />{t("Constant.kingBedSize")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <th className='th-row' scope="row"><Trans key="accomodation" html="br:<br/>">
                                                    {t("accomodation.contentTitle")}
                                                </Trans></th>
                                                <td>{t("accomodation.RM1950")}</td>
                                                <td>{t("accomodation.RM1950")}</td>
                                            </tr>
                                            <tr>
                                                <th className='th-row' scope="row">{t("accomodation.contentTitle2")}</th>
                                                <td>{t("accomodation.RM200")}</td>
                                                <td>{t("accomodation.RM200")}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div className="form-item mt-5">
                                        <label>
                                            <span style={{ color: "#ff0000", fontSize: "20px" }}>{t("accomodation.RoomType")}*</span>
                                        </label>
                                        <div className="image-radio-container">
                                            <div
                                                className={`room-radio-option ${selectedRoom === 'twinroom' ? 'selected' : ''}`}
                                                onClick={() => handleRoomSelection('twinroom')}
                                            >
                                                <span>
                                                    <img
                                                        src={`${base_url}/images/twinroom.JPG`}
                                                        alt="Twin Room"
                                                    />
                                                    {selectedRoom === 'twinroom' && <div className="tick-icon">✔</div>}
                                                </span>
                                                <p>{t("Constant.TwinRoom")} (MYR 1950)</p>
                                            </div>
                                            <div
                                                className={`room-radio-option ${selectedRoom === 'kingroom' ? 'selected' : ''}`}
                                                onClick={() => handleRoomSelection('kingroom')}
                                            >
                                                <span>
                                                    <img
                                                        src={`${base_url}/images/kingroom.JPG`}
                                                        alt="King Room"
                                                    />
                                                    {selectedRoom === 'kingroom' && <div className="tick-icon">✔</div>}
                                                </span>
                                                <p>{t("Constant.KingRoom")} (MYR 1950)</p>
                                            </div>
                                        </div>
                                    </div>
                                    {errors.room_type && <span className="error">{errors.room_type}</span>}
                                    <div className="form-item">
                                        {selectedRoom === "twinroom" ?
                                            <label>{t("accomodation.IFtwin")}
                                                <span style={{ "color": "#ff0000" }}>*</span>
                                            </label>
                                            :
                                            <label>{t("accomodation.IFking")}
                                                <span style={{ "color": "#ff0000" }}>*</span>
                                            </label>
                                        }
                                        <div className='radio'>
                                            <input className="form-check-input p-2" type="radio" name="is_addon_bed" id="1" onChange={handleInputChange} required />
                                            <p className='radioLabel mb-0'>{t("general.yes")} {t("accomodation.notCOMFORTABLE")}</p>
                                        </div>
                                        <div className='radio'>
                                            <input className="form-check-input p-2" type="radio" name="is_addon_bed" id="0" onChange={handleInputChange} required />
                                            <p className='radioLabel mb-0'>{t("general.no")}</p>
                                        </div>
                                    </div>
                                    {errors.is_addon_bed && <span className="error">{errors.is_addon_bed}</span>}
                                    <div className="form-item">
                                        <label>{t("accomodation.Roommate_Question")}
                                            <span style={{ "color": "#ff0000" }}>*</span></label>
                                        <div className='radio'>
                                            <input className="form-check-input" type="radio" name="is_roommate" id="1" onChange={handleInputChange} required />
                                            <p className='radioLabel mb-0'>{t("general.yes")}</p>
                                        </div>
                                        <div className='radio'>
                                            <input className="form-check-input p-2" type="radio" name="is_roommate" id="0" onChange={handleInputChange} required />
                                            <p className='radioLabel mb-0'>{t("accomodation.roomArrange")}</p>
                                        </div>
                                    </div>
                                    {errors.is_roommate && <span className="error">{errors.is_roommate}</span>}
                                    {formData?.is_roommate && formData?.is_roommate === "1" &&
                                        <>
                                            <div className="form-item">
                                                <label for="roommate_id" className="form-label">{t("accomodation.Roommate_ID")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                                <input type="text" className="form-control" id="roommate_id" placeholder="" onChange={handleInputChange} required />
                                            </div>
                                            {errors.roommate_id && <span className="error">{errors.roommate_id}</span>}
                                            <div className="form-item">
                                                <label for="roommate_name" className="form-label">{t("accomodation.Roommate_Name")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                                <input type="text" className="form-control" id="roommate_name" placeholder="" onChange={handleInputChange} required />
                                            </div>
                                            {errors.roommate_name && <span className="error">{errors.roommate_name}</span>}
                                            <div className="form-item">
                                                <label for="roommate_relationship" className="form-label">{t("accomodation.Roommate_Relationship")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                                <input type="text" className="form-control" id="roommate_relationship" placeholder="" onChange={handleInputChange} required />
                                            </div>
                                            {errors.roommate_relationship && <span className="error">{errors.roommate_relationship}</span>}
                                        </>
                                    }
                                    <div className='form-item'>
                                        <label for="check_in_date" className="form-label">{t("accomodation.checkInDate")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                        <input
                                            type='date'
                                            id="check_in_date"
                                            onChange={handleInputChange}
                                            value={formData.check_in_date || ""}
                                            min="2025-03-21"
                                            max="2025-03-26"
                                            required
                                        />
                                    </div>
                                    {errors.check_in_date && <p className='m-0'><span className="error">{errors.check_in_date}</span></p>}
                                    <div className='form-item'>
                                        <label for="check_out_date" className="form-label">{t("accomodation.checkOutDate")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                        <input
                                            type='date'
                                            id="check_out_date"
                                            onChange={handleInputChange}
                                            value={formData.check_out_date || ""}
                                            min="2025-04-01"
                                            max="2025-04-03"
                                            required
                                        />
                                    </div>
                                    {errors.check_out_date && <p className='m-0'><span className="error">{errors.check_out_date}</span></p>}
                                    {/* <div className="form-item">
                                        <label for="checkin-period" className="form-label">{t("accomodation.Check_IN_OUT")}<span style={{ "color": "#ff0000" }}>*</span></label>
                                        <input ref={buttonRef} type="text" className="form-control" onClick={() => setOpenDatePicker(!openDatePicker)} id="checkin_period" readOnly
                                            value={`${format(selectionRange.startDate, 'dd-MM-yyyy')}  to  ${format(selectionRange.endDate, 'dd-MM-yyyy')}`}
                                        />
                                    </div>


                                    {openDatePicker &&
                                        <div ref={calendarRef} style={{ "maxWidth": "350px" }}>
                                            <DateRange
                                                className=''
                                                ranges={[selectionRange]}
                                                onChange={handleSelect}
                                                minDate={new Date('2025-03-22')}
                                                maxDate={new Date('2025-04-03')}
                                                months={2}
                                                direction="vertical"
                                                preventSnapRefocus={true}
                                                showSelectionPreview={true}
                                                showMonthAndYearPickers={false}
                                                showDateDisplay={false}
                                                showMonthArrow={false}
                                            />
                                        </div>
                                    } */}
                                    <div className="form-item">
                                        <label>{t("accomodation.PaymentMethod")}
                                            <span style={{ "color": "#ff0000" }}>*</span></label>
                                        <div className='radio'>
                                            <input className="form-check-input p-2" type="radio" name="payment_mode" id="creditcard" onChange={handleInputChange} required />
                                            <p className='radioLabel mb-0'>{t("accomodation.Method1")}</p>
                                        </div>
                                        <div className='radio'>
                                            <input className="form-check-input p-2" type="radio" name="payment_mode" id="offline" onChange={handleInputChange} required />
                                            <p className='radioLabel mb-0'>{t("accomodation.Method2")}<span style={{ color: "#ff0000" }}>&nbsp;{t("accomodation.Method2Remind")}</span></p>
                                        </div>
                                    </div>
                                    {errors.payment_mode && <span className="error">{errors.payment_mode}</span>}

                                    <h4 className='mt-4'>{t("accomodation.CheckoutAmount")}</h4>
                                    <table className="table table-light table-striped">
                                        <thead>
                                            <tr>
                                                <th scope="col">{t("accomodation.AmtTitle")}</th>
                                                <th scope="col">{t("accomodation.AmtItem")}</th>
                                                <th scope="col">{t("accomodation.AMT")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <th className='th-row' scope="row">{t("accomodation.Roomselect")}</th>
                                                <td>{invoiceItemCopy.filter((item) => item.key === formData.room_type).map((item) => item.title)}</td>
                                                <td>MYR {checkoutItem.selectedRoomAmount}</td>
                                            </tr>
                                            <tr>
                                                <th className='th-row' scope="row">{t("accomodation.Early_C_I")}</th>
                                                <td>{earlyStayDay} {t("accomodation.days")}</td>
                                                <td>MYR {checkoutItem.earlyStayAmount}</td>
                                            </tr>
                                            <tr>
                                                <th className='th-row' scope="row">{t("accomodation.Extend_C_O")}</th>
                                                <td>{extendStayDay} {t("accomodation.days")}</td>
                                                <td>MYR {checkoutItem.extendStayAmount}</td>
                                            </tr>
                                            <tr>
                                                <th className='th-row' scope="row">{t("accomodation.TourismTax")}</th>
                                                <td>{passportRegion === "Malaysia" ? t("accomodation.msia") : t("accomodation.non_msia")}</td>
                                                <td>MYR {checkoutItem.tourismTax}</td>
                                            </tr>
                                            <tr>
                                                <th className='th-row' scope="row">{t("accomodation.TransactionFees")}</th>
                                                <td>{formData.payment_mode === "creditcard" ? t("accomodation.CreditCard") : t("accomodation.OfflineTransfer")}</td>
                                                <td>MYR {transactionFee}</td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td className='th-row'><strong>{t("accomodation.TotalRM")} ({t("accomodation.myr")})</strong></td>
                                                <td>
                                                    {
                                                        formData.room_type ?
                                                            formData.check_in_date && formData.check_out_date ?
                                                                <strong>{totalAmount.totalAmount}</strong> : <span style={{ color: "#ff0000" }}>{t("accomodation.chooseStayDate")}</span> :
                                                            <span style={{ color: "#ff0000" }}>{t("accomodation.tickRoomType")}</span>
                                                    }
                                                </td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td className='th-row'><strong>{t("accomodation.TotalCurrency")} ({currencySelected.key || "MYR"})</strong></td>
                                                <td>
                                                    {
                                                        formData.room_type ?
                                                            formData.check_in_date && formData.check_out_date ?
                                                                <strong>{totalAmount.totalAmountInCurrencySelected}</strong> : <span style={{ color: "#ff0000" }}>{t("accomodation.chooseStayDate")}</span> :
                                                            <span style={{ color: "#ff0000" }}>{t("accomodation.tickRoomType")}</span>
                                                    }
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    {paymentMethod === "offline" &&
                                        <>
                                            <div className="form-item">
                                                <label>{t("accomodation.cURRENCY")}
                                                    <span style={{ "color": "#ff0000" }}>*</span></label>
                                                <select className="form-select" onChange={handleCurrencyChange} id="offline_payment_currency" required>
                                                    <option value="">{t("accomodation.ChooseCurrency")}</option>
                                                    {currencyCopy.map((item, index) => (
                                                        <option key={index} value={item.key}>{item.currency}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            {errors.offline_payment_currency && <span className="error">{errors.offline_payment_currency}</span>}
                                            {
                                                currencySelected !== "" &&
                                                bankInfoCopy
                                                    .filter((i) => i.key === currencySelected.key)
                                                    .map((i, index) => (
                                                        <div className='section-title mb-2 mt-4' key={index}>
                                                            <p>
                                                                <strong>{i.title}</strong>
                                                                <br />
                                                                {i.subtitle}
                                                                <br />
                                                                {i.bank && <>{t("accomodation.bank")} {i.bank}<br /></>}
                                                                {i.image && <><img src={i.image} style={{ "width": "250px" }} alt="" /><br /></>}
                                                                {i.account && <>{t("accomodation.acc_Num")} {i.account} <br /></>}
                                                                {i.name && <>{t("accomodation.acc_Name")} {i.name}<br /></>}
                                                                {i.shiftcode && `SWIFT Code: ${i.shiftcode}`}
                                                            </p>
                                                        </div>
                                                    ))
                                            }
                                            <div className="form-item">
                                                <label for="transaction-prove" className="form-label">
                                                    {t("accomodation.Upload_Res")}
                                                    <span style={{ "color": "#ff0000" }}>*</span></label>
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    onChange={handleFileChange}
                                                    id="offline_payment_prove"
                                                />
                                            </div>
                                            <div className="form-info mt-2">
                                                <p className='mb-0'>{t("general.smallerFile")}</p>
                                            </div>
                                            {fileError && <div className="error mt-2">{fileError}</div>}
                                            {errors.offline_payment_prove && <span className="error">{errors.offline_payment_prove}</span>}
                                        </>
                                    }
                                    {paymentMethod === "creditcard" &&
                                        <Elements
                                            stripe={stripePromise}
                                            options={{
                                                mode: "payment",
                                                amount: convertToSubcurrency(((Number(netTotalAmount) + Number(checkoutItem.tourismTax) + 1) / 0.96).toFixed(2)),
                                                currency: "myr",
                                            }}
                                        >
                                            <Checkout
                                                amount={((Number(netTotalAmount) + Number(checkoutItem.tourismTax) + 1) / 0.96).toFixed(2)}
                                                formData={setNullFormToEmpty(formData)}
                                                validateAllFields={validateAllFields}
                                                checkoutItem={checkoutItem}
                                                transactionFee={Number(((0.04 * (Number(netTotalAmount) + Number(checkoutItem.tourismTax)) + 1) / 0.96))}
                                                netTotalAmount={Number(netTotalAmount)}
                                                generateValidationFields={generateValidationFields}
                                            />
                                        </Elements>
                                    }
                                </div>

                            </div>
                            <div className='form-section-4' hidden={formSection !== 4}>
                                <div className='section-title mb-2'>
                                    <h4 className='mb-0'>{t("accomodation.SubmitForm")}</h4>
                                </div>
                                <div className='section-description pt-2 pb-3'>
                                    <p>
                                        {t("accomodation.Thankyou")} <br />
                                        <span style={{ "color": "#ff0000" }}><strong>{t("accomodation.TQred")}</strong></span>
                                    </p>
                                    <Trans key="accomodation" html="br:<br/>">
                                        <br />{t("general.Declaration1")}
                                    </Trans>
                                    <p>
                                        <strong>{t("general.contact_Info")}</strong>
                                        <Trans key="general" html="br:<br/>">
                                            {t("general.infoContent")}
                                            <a href="mailto:retreat@shineling.org">{t("general.retreatEmail")}</a>
                                        </Trans>
                                        <br />
                                        <Link to="https://www.shineling.org:3004" target="_blank" rel="noopener noreferrer">
                                            {t("general.retreatChatbot")}
                                        </Link>
                                    </p>
                                    <p>
                                        -----------------------------
                                        <Trans key="general" html="br/:<br />">
                                            <br />{t("general.snl")}
                                        </Trans>
                                    </p>
                                </div>
                            </div>
                            <div className='button-container mt-3'>
                                <Button buttonStyle="btn--primary" hidden={formSection === 1} type="button" onClick={() => navigateFormSection(false)}>{t("general.BTNprevious")}</Button>
                                <Button buttonStyle="btn--primary" hidden={formSection === 3} type="button" onClick={() => navigateFormSection(true)}>{t("general.BTNnext")}</Button>
                                {paymentMethod === "offline" &&
                                    <Button buttonStyle="btn--primary" hidden={formSection !== 3} onClick={handleSubmit} type="button">
                                        {isSubmitting ? <AiOutlineLoading className="spin" /> : t("general.BTNsubmit")}
                                    </Button>
                                }
                            </div>

                        </form>
                    </div>
                </>
            }
        </>
    )
}

export default CreateAccomodation